/** @format */
import { ChangeDetectionStrategy, Component, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { CustomCourseUnitAttainment } from 'common-typescript/types';
import { customAttainmentCreditInfoModalOpener, StudyBoxType } from 'sis-components';

@Component({
    selector: 'app-timeline-custom-course-unit-attainment',
    standalone: false,
    templateUrl: './timeline-custom-course-unit-attainment.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineCustomCourseUnitAttainmentComponent {
    readonly customCourseUnitAttainment: InputSignal<CustomCourseUnitAttainment> = input.required<CustomCourseUnitAttainment>();
    readonly headingLevel: InputSignal<number> = input.required<number>();

    private readonly customAttainmentCreditInfoModalOpener = customAttainmentCreditInfoModalOpener();

    protected openCustomAttainmentCreditInfoModal(customAttainment: CustomCourseUnitAttainment): void {
        this.customAttainmentCreditInfoModalOpener(customAttainment);
    }

    protected readonly StudyBoxType = StudyBoxType;
}
